import { Card, CardBody, Table } from 'reactstrap';
import { QueryLoadingState, QueryErrorState } from './QueryStates';

/**
 * Konsistenter Wrapper um eine Reactstrap-Tabelle.
 *
 * Composition-API: View liefert eigene `<thead>` + `<tbody>` als children.
 * `DataTable` rendert Loading- / Error- / Empty-States außerhalb der Tabelle,
 * damit die Header-Row nicht doppelt sichtbar wird.
 *
 * @example
 * <DataTable
 *   loading={query.isLoading}
 *   error={query.error}
 *   empty={!rows.length}
 *   emptyMessage="Keine Einträge."
 *   onRetry={() => query.refetch()}
 * >
 *   <thead><tr><th>ID</th>...</tr></thead>
 *   <tbody>{rows.map(...)}</tbody>
 * </DataTable>
 */
export function DataTable({
  loading,
  error,
  empty,
  emptyMessage = 'Keine Einträge.',
  onRetry,
  children,
  hover = true,
  size = 'sm',
}) {
  if (loading) return <QueryLoadingState />;
  if (error) return <QueryErrorState error={error} onRetry={onRetry} />;

  return (
    <Card>
      <CardBody className="p-0">
        <div className="table-responsive">
          <Table hover={hover} size={size} className="mb-0 align-middle">
            {children}
          </Table>
        </div>
        {empty && (
          <div className="text-center text-muted py-5">{emptyMessage}</div>
        )}
      </CardBody>
    </Card>
  );
}
